@if (headerConfig) {
  <div
    class="saas-ui d-flex align-items-center py-3 bg-white justify-content-between {{
      headerConfig.containerStyleClass
    }}">
    <span
      class="d-flex align-items-center gap-1"
      [ngClass]="
        headerConfig.primaryTitle?.span
          ? 'col-md-' + headerConfig.primaryTitle?.span
          : 'col-md-12'
      "
      [ngClass]="headerConfig.faq ? 'col-md-8' : 'col-md-12'">
      @if (
        headerConfig.primaryTitle?.field ||
        headerConfig.primaryTitle?.defaultValue
      ) {
        <div
          class="DASHBOARD_TITLE_HEADING"
          id="primaryTitle"
          [ngClass]="headerConfig.primaryTitle.styleClass">
          {{
            headerData[headerConfig.primaryTitle.field] ||
              headerConfig.primaryTitle.defaultValue ||
              "No Data"
          }}
          {{
            headerConfig.secondaryTitles && headerConfig.secondaryTitles.length
              ? "|"
              : ""
          }}
        </div>
      }
      @for (
        secondaryTitle of headerConfig.secondaryTitles;
        track secondaryTitle
      ) {
        <h3
          class="pe-2"
          id="secondaryTitle"
          [ngClass]="secondaryTitle.styleClass">
          {{ headerData[secondaryTitle.field] || "No Data" }}
        </h3>
      }
      @if (headerConfig.editableTitle?.field) {
        @if (!isEditMode) {
          <h3
            [ngClass]="{
              DASHBOARD_TITLE_HEADING: i === 0,
              'd-block pe-2 mb-0': true,
            }">
            {{ headerData[headerConfig.editableTitle.field] ?? "No Data" }}
          </h3>
        }
        @if (isEditMode) {
          <input
            class="editable-input pe-2"
            (keyup)="onEditableHeaderKeyUp($event)"
            type="text"
            value="{{
              headerData[headerConfig.editableTitle.field] ?? 'No Data'
            }}"
            autofocus />
        }
      }
      @for (badge of headerConfig.badges; track badge) {
        @if (showEmptyData || (!showEmptyData && headerData[badge.field])) {
          <p-badge
            [severity]="badge.severity || 'success'"
            [size]="badge.severity || 'large'"
            [class]="badge.styleClass || 'BADGE'"
            value="{{ headerData[badge.field] || 'No Data' }}">
          </p-badge>
        }
      }
      @if (headerConfig.tags?.length !== 0) {
        @for (tag of headerConfig.tags; track tag) {
          @if (showEmptyData || (!showEmptyData && headerData[tag.field])) {
            <m-type-pill [size]="tag.size" [text]="tag.text || ''">
            </m-type-pill>
          }
        }
      }
    </span>
    <div class="d-flex align-items-center gap-3">
      <ng-content select="[customContent]"></ng-content>
      @if (infoConfig) {
        <div class="d-flex saas-ui-size-default gap-3">
          @for (config of infoConfig; track config) {
            <span [ngClass]="config.styleClass">
              {{ config.label }}
            </span>
          }
        </div>
      }
      @if (actionButtonConfig) {
        <div class="d-flex saas-ui-size-default gap-3">
          @for (actionButton of actionButtonConfig; track actionButton) {
            <button
              pButton
              [ngClass]="actionButton.styleClass"
              label="{{ actionButton.label }}"
              [disabled]="actionButton.disabled"
              (click)="onClickAction(actionButton.value)"></button>
          }
        </div>
      }
      @if (headerConfig.faq) {
        <div>
          <m-tooltip
            content="<div class='b1 text-gray-000 text-center'>{{
              headerConfig.faq.label
            }}</div>"
            (click)="onClickFAQ(headerConfig.faq.field)"
            position="bottom"
            [tooltipOptions]="{
              positionTop: 10,
              showDelay: 800,
            }">
            <m-button
              [type]="'primary'"
              class="saas-ui-size-default"
              [attr.data-tracker]="
                this.dataTrackerService.generateKeySuffix(
                  'm_button__learn_more--',
                  headerData[headerConfig.primaryTitle.field] ||
                    headerConfig.primaryTitle.defaultValue ||
                    ''
                )
              ">
              <span class="b2 lh-1 text-nowrap">Learn more</span>
            </m-button>
          </m-tooltip>
        </div>
      }
    </div>
  </div>
}
